// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".binfo-settings .btn-delete{margin:30px 0 40px;border-radius:30px!important;font-size:12px!important;font-weight:700!important;background-color:#595963!important;border:2px #595963!important;line-height:21px;color:#fff;padding:8px 20px!important}.binfo-settings .form-group{margin-top:16px}.binfo-settings .form-control{border-color:#d6dde5;font-size:.9rem!important;padding:1.075rem .75rem!important}.binfo-settings .form-control:focus{border:1px solid #b1b8c4}", ""]);
// Exports
module.exports = exports;
